import { Box, makeStyles } from '@material-ui/core';
import type { ReactNode } from 'react';

import { SNavigateButton, SText } from '@setvi/shared/components';

const HEADER_HEIGHT = 55;

const useStyles = makeStyles(({ spacing }) => ({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    zIndex: 1300,
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(1.5),
    padding: spacing(2),
    height: HEADER_HEIGHT,
    flexShrink: 0
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0
  }
}));

interface MobileResourceOverlayProps {
  title: string;
  onBack: () => void;
  /** The preview: the Setvi viewer iframe, or the product-assets preview. */
  children: ReactNode;
}

/** Full-screen in-page preview of one resource. Mobile has no tab to close,
 *  so the back button in the header returns to the list. */
export const MobileResourceOverlay = ({
  title,
  onBack,
  children
}: MobileResourceOverlayProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.overlay}>
      <Box className={classes.header}>
        <SNavigateButton onClick={onBack} />
        <SText weight="semibold" title={title} />
      </Box>
      <Box className={classes.body}>{children}</Box>
    </Box>
  );
};
